import { Card as ReactCard } from 'react-bootstrap';
import { isEmpty, truncate } from 'lodash';
import classnames from 'classnames';
import parse from 'html-react-parser';
import { Badges } from './Badges';
import { LOGOS } from './helpers';
import { CardTypes } from './prop_types';

const Card = ({
  title,
  previewImage,
  previewText,
  url,
  target,
  fromPrice,
  productPrice,
  productSalePrice,
  productPriceDefinition,
  badgeText,
  badges,
  isAffiliate,
  affiliateLogo,
  hasResourceId,
  tenant,
  dateString,
  ctaButtonText,
  blogCategory,
  type,
  postDate,
  className,
  buttonClassName,
  hidePrice = false,
}) => {
  const isOnSale =
    !!productSalePrice && !!window.ecom.craftConfig.showMarketingDiscounts;
  const savedMoney = isOnSale ? productPrice - productSalePrice : 0;
  const buttonText =
    ctaButtonText ||
    (isAffiliate || hasResourceId ? 'Book now' : 'Find out more');
  const openIn = isAffiliate ? '_blank' : target || '_self';

  return (
    <>
      <a
        className={classnames(
          `h-100 d-block text-reset text-decoration-none card-badge__container image-hover card__container ${
            className || ''
          }`,
          {
            'affiliate-link': isAffiliate,
          }
        )}
        target={openIn}
        href={url}
        /* eslint-disable react/jsx-props-no-spreading */
        {...(isAffiliate && { 'data-affiliate-title': title })}
      >
        <ReactCard className="h-100 overflow-hidden">
          <div className="overflow-hidden">
            <ReactCard.Img
              loading="lazy"
              variant="top"
              src={previewImage.url}
              width={previewImage.width}
              height={previewImage.height}
              alt={previewImage.alt}
            />
          </div>
          <ReactCard.Body className="d-flex flex-column gap-2">
            {type === 'news' && !isEmpty(postDate) && (
              <time className="mt-2">{postDate}</time>
            )}
            <h3 className="common-card__title">{title}</h3>
            {tenant && (
              <p>
                <i className="fa-regular fa-location-dot me-1" />
                {tenant}
              </p>
            )}
            {dateString && (
              <p>
                <i className="fas fa-calendar-alt text-primary icon__before-text" />
                {dateString}
              </p>
            )}
            {blogCategory && (
              <div className="text-tertiary">{blogCategory?.title}</div>
            )}
            <div className="common-card__description">
              {parse(truncate(previewText, { length: 200, separator: ' ' }))}
            </div>
          </ReactCard.Body>
          <ReactCard.Footer className="bg-white border-top-0 pb-3">
            {!hidePrice && productPrice && (
              <div className="text-grey">
                {fromPrice && (
                  <div className="common-card__from-word">From</div>
                )}
                <div>
                  <span className="fw-bold text-primary common-card__price">
                    ${isOnSale ? productSalePrice : productPrice}
                  </span>
                  {productPriceDefinition && (
                    <span className="common-card__price-definition">
                      &nbsp;{productPriceDefinition}
                    </span>
                  )}
                </div>
                {isOnSale && (
                  <div>
                    Normally <del>${productPrice}</del>.&nbsp;
                    <span className="fw-bold">Save ${savedMoney}.</span>
                  </div>
                )}
              </div>
            )}
            <div className="mt-2 d-flex justify-content-between align-items-end">
              <div
                className={classnames(
                  `btn ${buttonClassName || 'btn-primary'} common-card__button`
                )}
              >
                {buttonText}
              </div>
              {affiliateLogo && (
                <div className="text-grey common-card__affiliate">
                  Powered by
                  <img
                    src={LOGOS[affiliateLogo].logo}
                    alt={LOGOS[affiliateLogo].alt}
                    className="no-transform common-card__affiliate-logo"
                  />
                </div>
              )}
            </div>
          </ReactCard.Footer>
        </ReactCard>
        {!isEmpty(badges) && <Badges badges={badges} />}
        {isEmpty(badges) && badgeText && (
          <div className="card-badge__badge">{badgeText}</div>
        )}
      </a>
    </>
  );
};

export default Card;

Card.propTypes = CardTypes;
